import { NgTemplateOutlet } from '@angular/common';
import type { SimpleChanges, TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, output, input } from '@angular/core';
import type { UntypedFormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  IconButtonComponent,
  InputComponent,
  PhoneInputComponent,
  TextareaComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-profile-information-editor-group-entry',
  styleUrls: ['./candidate-profile-information-editor-group-entry.component.less'],
  templateUrl: './candidate-profile-information-editor-group-entry.component.html',
  host: {
    '[class.editing]': 'editing()',
    '[class.dragable]': 'allowReorder()',
    '[attr.margin-bottom-small]': '!isLast() || null',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    PhoneInputComponent,
    ReactiveFormsModule,
    InputComponent,
    TextareaComponent,
    IconButtonComponent,
    TranslatePipe,
  ],
})
export class CandidateProfileInformationEditorGroupEntryComponent {
  public readonly multiline = input<boolean>(false);
  public readonly editing = input<boolean>(undefined!);
  public readonly allowReorder = input<boolean>(false);
  public readonly placeholder = input<string>('placeholder');
  public readonly autofocus = input<boolean>(false);
  public readonly isLast = input<boolean>(false);
  public readonly editPhoneNumber = input<boolean>(undefined!);
  public readonly countryCode = input<string | null>(undefined!);
  @Input() public parent: UntypedFormControl;
  @Input() public previewTpl: TemplateRef<any>;

  public remove = output<void>();
  public blur = output<UntypedFormControl>();

  public controlContext: { $implicit: string };

  public ngOnChanges(changes: SimpleChanges): void {
    if ('parent' in changes) {
      this.controlContext = { $implicit: this.parent.value };
    }
  }
}
